import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleIndicator = ({ activeTab }) => {
  const roleInfo = {
    email: {
      roles: ['Owner/Admin', 'Manager', 'Coach', 'Staff'],
      description: 'Full academy management access',
      icon: 'Shield',
      color: 'text-primary'
    },
    code: {
      roles: ['Student'],
      description: 'Personal portal and progress tracking',
      icon: 'User',
      color: 'text-accent'
    }
  };

  const info = roleInfo?.[activeTab];

  if (!info) return null;

  return (
    <div className="w-full max-w-md mb-6">
      <div className="bg-muted/50 rounded-lg p-4 border border-border">
        <div className="flex items-start space-x-3">
          <div className={`p-2 rounded-lg bg-card ${info?.color}`}>
            <Icon name={info?.icon} size={16} color="currentColor" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex flex-wrap gap-1 mb-2">
              {info?.roles?.map((role, index) => (
                <span
                  key={role}
                  className="inline-flex items-center px-2 py-1 rounded-md bg-card text-xs font-medium text-foreground"
                >
                  {role}
                </span>
              ))}
            </div>
            <p className="text-xs text-muted-foreground">
              {info?.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleIndicator;